<template>
  <div class="animate__animated animate__fadein animate__delay-0.5s animate__slower">
    <div class=" time">上次更新时间：{{ year }}年{{ month }}月{{ day }}日{{ hour }}：{{ minute }}</div>
    <div style="width: 100% ;height:auto;margin-top: .1354rem; display: flex; justify-content: space-between;">
      <div> <img :src="'https://www.cdjjwang.com/' + this.avatar" style="width: .7813rem;height: 1.0417rem;">

        <el-upload class="upload-demo" action="/Api/Teacher/Honest" accept="image/jpg,image/png"
          :on-preview="handlePreview" :on-remove="handleRemove" :limit="1" :on-exceed="handleExceed"
          :file-list="fileList" :before-remove="beforeRemove" :on-success="upSuccess" :http-request="uploadFile"
          :auto-upload="true">
          <img src="../../assets/teacherChangeHead.png" alt=""
            style="width: .4583rem;height: .1667rem;margin-top: .1042rem;">
          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
        </el-upload>

      </div>

      <div style="width: 2.5521rem;height: 100%;" id="basic">

        <div style="display: flex;margin-bottom: .0729rem; ">
          <div class="title"><img src="../../assets/TjianliHead.png" alt="" style="width: .0729rem;height: .0885rem;">
            <div style="margin-left: .0469rem;">姓名</div>
          </div>
          <div class="answer"><input type="text" placeholder="请输入" class="emptyinput" v-model="username">
          </div>
        </div>
        <div style="display: flex;margin-bottom: .0729rem; ">
          <div class="title">
            <img src="../../assets/TjianliPhone.png" alt="">
            <div>联系方式</div>
          </div>
          <div class="answer"><input type="text" placeholder="请输入" class="emptyinput" v-model="phone">
          </div>
          <button class="button" @click="yanzhengma">{{ yanzhengmatext }}</button>
        </div>
        <div style="display: flex;margin-bottom: .0729rem; ">
          <div class="title">
            <img src="../../assets/TjianliPhone.png" alt="">
            <div>验证码</div>
          </div>
          <div class="answer"><input type="text" placeholder="请输入" class="emptyinput" v-model="phonecode">
            <button class="button" @click="yanzhengcode"
              style="margin-left: 0.03rem;transform: translateY(0.001rem);">验证</button>
          </div>
        </div>
        <div style="display: flex;margin-bottom: .0729rem; ">
          <div class="title"><img src="../../assets/TjianliSex.png" alt="">
            <div>性别</div>
          </div>
          <div class="answer">
            <template>
              <el-radio-group v-model="sex" text-color="#606266">
                <el-radio :label="1">女</el-radio>
                <el-radio :label="0">男</el-radio>
              </el-radio-group>
            </template>
          </div>
        </div>
        <div style="display: flex;margin-bottom: .0729rem; ">
          <div class="title"><img src="../../assets/TjianliQuality.png" alt="">
            <div>教师资格证</div>
          </div>
          <div class="answer"> <template>
              <el-radio-group v-model="quality" text-color="#606266">
                <el-radio :label="0">有</el-radio>
                <el-radio :label="1">无</el-radio>
              </el-radio-group>
            </template></div>
        </div>
        <div style="display: flex;margin-bottom: 0rem; ">
          <div class="title" style="display:flex"><img src="../../assets/TjianliClass.png" alt=""
              style="transform: translateY(.0052rem);">
            <div>授课范围</div>
          </div>
          <div class="fanwei">
            <template>
              <div>
                <div v-for="(cascader, index) in  fanweichecked " :key="index">
                  <el-cascader v-model="cascader.value" :options="fanwei" placeholder="请选择" :style="{
      width: '.7448rem', height: '.125rem', margin: '.0365rem 0', transform: 'translateY(-0.0417rem)'
    }"></el-cascader>
                  <!-- 如果是最后一个选择器组，就显示加号按钮 -->
                  <el-button v-if="index === fanweichecked.length - 1" type="primary" icon="el-icon-plus" circle
                    v-on:click="addCascader"
                    :style="{ backgroundColor: 'rgb(1, 162, 153)', width: '.0781rem', height: '.0781rem', padding: '0', fontSize: '.056rem', transform: 'translateY(-0.026rem)' }"></el-button>
                  <!-- 如果不是第一个选择器组，就显示删除按钮 -->
                  <el-button v-else type="danger" icon="el-icon-close" circle v-on:click="deleteCascader(index)"
                    :style="{ width: '.0781rem', height: '.0781rem', padding: '0', fontSize: '.056rem', transform: 'translateY(-0.0417rem)' }"></el-button>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div style="display: flex;margin-bottom: .0729rem;transform: translateY(-0.0365rem);">
          <div class="title"><img src="../../assets/TjianliIdentity.png" alt="">
            <div>身份</div>
          </div>
          <div class="answer" id="identity"><template>
              <el-select v-model="identitychecked" placeholder="请选择" :style="{
      width: '.7448rem', height: '.125rem', margin: '.026rem 0', transform: 'translate(-0.0208rem,-0.0104rem)',
    }">
                <el-option v-for="item in identity" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </template>
          </div>
        </div>

      </div>
    </div>
    <div style="width: 3.0729rem;height: .4896rem;margin-top: .1094rem;" id="edu" v-if="this.identitychecked == 0">
      <div class="flex">
        <div style="display: flex;margin-bottom: 0rem; ">
          <div class="title" style="width: .714rem;">
            <img src="../../assets/TjianliXuewei.png" alt="">
            <div>学历</div>
          </div>
          <div class="answer"><el-select v-model="biye.xueweichecked" placeholder="请选择" :style="{ width: '.5448rem' }">
              <el-option v-for="item in this.biye.xuewei" :key="item.value" :value="item.value" :label="item.label">
              </el-option>
            </el-select>
          </div>
        </div>
        <div style="display: flex;margin-bottom: 0rem; ">
          <div class="title">
            <img src="../../assets/TjianliZhiye.png" alt="">
            <div style="margin-right: 0;">职业类型</div>
          </div>
          <div class="answer">
            <el-select v-model="biye.zhiyechecked" placeholder="请选择" :style="{ transform: 'translateY(.0156rem)' }">
              <el-option v-for="item in this.biye.zhiye" :key="item.value" :value="item.value" :label="item.label">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>

      <div style="display: flex;margin-bottom: 0rem; margin-top: .0677rem;">
        <div class="title" style="width: .8rem;">
          <img src="../../assets/TjianliSchool.png" alt="">
          <div>毕业学校</div>
        </div>
        <div class="answer"><input type="text" class="emptyinput" v-model="biye.school"
            :style="{ transform: 'translateY(.0156rem)', width: '2.3583rem' }"></div>
      </div>
      <div style="display: flex;margin-bottom: 0rem; margin-top: .0677rem;">
        <div class="title" style="width: .8rem;">
          <img src="../../assets/TjianliZhuanye.png" alt="">
          <div>专业</div>
        </div>
        <div class="answer"><input type="text" class="emptyinput" v-model="biye.zhuanye"
            :style="{ transform: 'translateY(.0156rem)', width: '2.3583rem' }"></div>
      </div>
    </div>
    <div style="width: 3.0729rem;height: auto;margin-top: .1094rem;" id="edu" v-else>
      <div class="flex">
        <div style="display: flex;margin-bottom: 0rem; ">
          <div class="title">
            <img src="../../assets/TjianliXuewei.png" alt="">
            <div style="width: .2604rem;">年级</div>
          </div>
          <div class="answer">
            <el-select v-model="daxuesheng.xueweichecked" placeholder="请选择" :style="{ width: '.7448rem' }">
              <el-option v-for="item in this.daxuesheng.xuewei" :key="item.value" :value="item.value"
                :label="item.label">
              </el-option>
            </el-select>
          </div>
        </div>
        <div style="display: flex;margin-bottom: 0rem; ">
          <div class="title">
            <img src="../../assets/TjianliZhuanye.png" alt="">
            <div style="width: .2604rem;">专业</div>
          </div>
          <div class="answer"> <input type="text" class="emptyinput" v-model="daxuesheng.zhuanye"
              :style="{ transform: 'translateY(.0156rem)' }"></div>
        </div>
      </div>
      <div style="display: flex;margin-bottom: 0rem; margin-top: .0677rem;">
        <div class="title">
          <img src="../../assets/TjianliSchool.png" alt="">
          <div style="width: 0.36rem;margin-right: 0;">就读高校</div>
        </div>
        <div class="answer"><input type="text" class="emptyinput" v-model="daxuesheng.school"
            :style="{ transform: 'translateY(.0156rem)', width: '2.563rem' }"></div>
      </div>

    </div>
    <!-- <div
      style="width: .375rem;height: .125rem;color: rgb(1, 162, 153);font-family: 苹方;font-size: .0938rem;font-weight: 600;line-height: .125rem;letter-spacing: 0rem;text-align: left;margin-top: .0833rem;">
      自我介绍
    </div>
    <div style="width: 3.4167rem;height: .0104rem;background: rgb(1, 162, 153);margin-top: .0208rem;"></div> -->
    <div class="answer"> <input :rows="2" placeholder="一句话自我介绍" v-model="comment"
        :style="{ width: '3.0625rem', marginTop: '.0885rem', marginBottom: '.1042rem', height: '.125rem' }"
        class="emptyinput"></div>

    <div class="introduce">
      <div class="title">
        <img src="../../assets/TjianliJiangbei.png" alt="">
        <div>获奖经历</div>
      </div>
      <el-input type="textarea" :rows="6"
        placeholder="填写获奖经历，如初高中(奥赛、英语比赛、作文大赛奖项分数等)大学&研究生相关证书/技能证明，四六级分数/高考分数，证书颁证方/等级工作后教育相关奖项" v-model="award"
        :style="{ marginTop: '.0208rem', width: '3.0625rem', marginBottom: '.0833rem', fontSize: '.0625rem' }">
      </el-input>
      <div class="title">
        <img src="../../assets/TjianliJiaoxue.png" alt="">
        <div>教学经历</div>
      </div>
      <el-input type="textarea" :rows="6" placeholder="填写教学经历，模板: xx年x月—xx月，教XX年级XX学科XX同学，通过多长时间运用XX方法取得XX效果"
        v-model="teachExp"
        :style="{ marginTop: '.0208rem', width: '3.0625rem', marginBottom: '.0833rem', fontSize: '.0625rem' }">
      </el-input>
      <div class="title">
        <img src="../../assets/TjianliZiwo.png" alt="">
        <div>自我评价</div>
      </div>
      <el-input type="textarea" :rows="6" placeholder="填写自我评价，可写自己的教学方法、个人性格特点、做事风格、其他对于家教的想法/感受等" v-model="selfAssess"
        :style="{ marginTop: '.0208rem', width: '3.0625rem', marginBottom: '.0833rem', fontSize: '.0625rem' }">
      </el-input>
    </div>
    <div id="course">
      <!-- <div
        style="width: .375rem;height: .125rem;color: rgb(1, 162, 153);font-family: 苹方;font-size: .0938rem;font-weight: 600;line-height: .125rem;letter-spacing: 0rem;text-align: left;margin-bottom: .1042rem;">
        授课情况
      </div> -->
      <div class="flex" style="justify-content: left;margin: .0833rem 0 .0833rem 0;">
        <div class="title"><img src="../../assets/TjianliTime.png" alt="">
          <div>授课时间</div>
        </div>
        <div class="answer" id="quyu" style="height: .1771rem;"><el-select v-model="studytimechecked" placeholder="请选择"
            multiple :collapse-tags="ifcollapsetime" :style="{ width: '1.9948rem', height: '.177rem' }">
            <el-option v-for="item in this.studytime" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select></div>
      </div>

      <!-- <div class="flex" style="width: 2.7083rem;margin-top: .099rem;"> -->
      <div class="flex" style="justify-content: left;margin: .0833rem 0 .0833rem 0;">
        <div class="title"><img src="../../assets/TjianliLocation.png" alt="">
          <div>授课区域</div>
        </div>
        <div class="answer" id="quyu" style="height: .1771rem;"><el-select v-model="locationchecked" placeholder="请选择"
            multiple :collapse-tags="ifcollapsequyu" :style="{ width: '1.9948rem', height: '.177rem' }">
            <el-option v-for="item in this.location" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select></div>
      </div>
      <div class="flex" style="justify-content: left;margin: .0833rem 0 .0833rem 0;">
        <div class="title"><img src="../../assets/TjianliFangshi.png" alt="">
          <div>辅导方式</div>
        </div>
        <div class="answer" style="height: 0.177rem !important;"><el-select v-model="teachMethodchecked"
            placeholder="请选择" :style="{ width: '.9448rem' }">
            <el-option v-for="item in teachMethod" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select></div>
      </div>
      <!-- </div> -->
      <div class="flex answer" style="width: 2.2208rem;margin-top: .1042rem;">
        <div class="title"><img src="../../assets/TjianliMoney.png" alt="">
          <div style="width: 0.3rem;">课时费</div>
        </div>
        <input type="number" class="emptyinput" v-model="money1"
          style="border-radius: .0208rem;width: .3698rem;height: .125rem; transform: translateY(-0.0156rem);">元/小时
        至
        <input type="number" class="emptyinput" v-model="money2"
          style="border-radius: .0208rem;width: .3698rem;height: .125rem;transform: translateY(-0.0156rem);">元/小时
      </div>
    </div>
    <img src="../../assets/teacherSubmitjianli.png" style="width: .4583rem;height: .1667rem;margin-top: .0781rem;"
      alt="" @click="submit()">
    <div style="width: 3.0469rem; height: 1.0417rem;"></div>

  </div>
</template>

<script>
import { all } from 'axios';

export default {
  data() {
    return {
      year: '',
      phonecode: '',
      yanzhengmatext: '获取验证码',
      month: '',
      day: '',
      hour: '',
      minute: '',
      username: '',
      comment: '',
      phone: '',
      sex: 0,
      avatar: '',
      quality: 0,
      ifcollapsequyu: false,
      ifcollapsetime: false,
      identity: [{
        value: 0,
        label: '已毕业'
      }, {
        value: 1,
        label: '在读大学生'
      },],
      identitychecked: '',
      biye: {
        xuewei: [{
          value: 0,
          label: '专科'
        }, {
          value: 1,
          label: '本科'
        }, {
          value: 2,
          label: '硕士'
        }, {
          value: 3,
          label: '博士'
        }],
        xueweichecked: '',
        zhuanye: "",
        zhiye: [
          {
            value: 0,
            label: '公立学校任教'
          }, {
            value: 1,
            label: '私立学校任教'
          }, {
            value: 2,
            label: '线上/线下培训机构任教'
          }, {
            value: 3,
            label: '非教育培训类工作'
          }
        ],
        zhiyechecked: 0,
        school: "",
      },
      daxuesheng: {
        xuewei: [{
          value: 0,
          label: '本科一年级'
        }, {
          value: 1,
          label: '本科二年级'
        }, {
          value: 2,
          label: '本科三年级'
        }, {
          value: 3,
          label: '本科四年级'
        }, {
          value: 4,
          label: '硕士'
        }, {
          value: 5,
          label: '博士'
        },],
        xueweichecked: '',
        zhuanye: "",
        school: ''

      },
      fileList: [],
      studytime: [
        {
          value: 0,
          label: '周一到周五晚上'
        }, {
          value: 1,
          label: '周一到周五全天'
        }, {
          value: 2,
          label: '周六上午'
        }, {
          value: 3,
          label: '周六下午'
        }, {
          value: 4,
          label: '周六晚上'
        }, {
          value: 5,
          label: '周日上午'
        }, {
          value: 6,
          label: '周日下午'
        }, {
          value: 7,
          label: '周日晚上'
        }, {
          value: 8,
          label: '寒暑假均可'
        },],
      studytimechecked: [],
      selected: [],
      // fangshi: "不限",
      money1: 50,
      money2: 100,
      fanweichecked: [{
        value: [],
      }
      ],
      fanwei: [
        {
          value: "1",
          label: "小学",
          children: [
            {
              value: "0",
              label: "全科",
            },
            {
              value: "1",
              label: "语文",
            },
            {
              value: "2",
              label: "奥数",
            },
            {
              value: "3",
              label: "数学",
            },
            {
              value: "4",
              label: "英语",
            },
            {
              value: "5",
              label: "作业辅导",
            },

          ],
        },
        {
          value: "2",
          label: "初中",
          children: [
            {
              value: "0",
              label: "全科",
            },
            {
              value: "1",
              label: "语文",
            },
            {
              value: "2",
              label: "英语",
            },
            {
              value: "3",
              label: "数学",
            },
            {
              value: "4",
              label: "物理",
            },
            {
              value: "5",
              label: "化学",
            },

          ],
        },
        {
          value: "3",
          label: "高中",
          children: [
            {
              value: "0",
              label: "数学",
            },
            {
              value: "1",
              label: "语文",
            },
            {
              value: "2",
              label: "英语",
            },
            {
              value: "3",
              label: "物理",
            },
            {
              value: "4",
              label: "化学",
            },
            {
              value: "5",
              label: "生物",
            },
            {
              value: "6",
              label: "历史",
            },
            {
              value: "7",
              label: "政治",
            },
            {
              value: "8",
              label: "地理",
            },

          ],
        },
        {
          value: "4",
          label: "小语种",
          children: [
            {
              value: "0",
              label: "法语",
            },
            {
              value: "1",
              label: "德语",
            },
            {
              value: "2",
              label: "西班牙语",
            },
            {
              value: "3",
              label: "日语",
            },
            {
              value: "4",
              label: "葡萄牙语",
            },
            {
              value: "5",
              label: "韩语",
            },

          ],
        },
        {
          value: "5",
          label: "艺体类",
          children: [
            {
              value: "0",
              label: "音乐",
            },
            {
              value: "1",
              label: "美术",
            },
            {
              value: "2",
              label: "舞蹈",
            },
            {
              value: "3",
              label: "体育",
            },
          ],
        }, {
          value: "60",
          label: "其他",

        },
      ],
      award: '',
      teachExp: '',
      selfAssess: '',
      location: [{
        value: 0,
        label: '锦江区'
      }, {
        value: 1,
        label: '金牛区'
      }, {
        value: 2,
        label: '武侯区'
      }, {
        value: 3,
        label: '青羊区'
      }, {
        value: 4,
        label: '成华区'
      }, {
        value: 5,
        label: '高新区'
      }, {
        value: 6,
        label: '天府新区'
      }, {
        value: 7,
        label: '新都区'
      }, {
        value: 8,
        label: '郫都区'
      }, {
        value: 9,
        label: '双流区'
      }, {
        value: 10,
        label: '龙泉驿区'
      }, {
        value: 11,
        label: '温江区'
      }, {
        value: 13,
        label: '都江堰'
      }, {
        value: 14,
        label: '彭州'
      }, {
        value: 15,
        label: '邛崃'
      }, {
        value: 16,
        label: '崇州'
      }, {
        value: 17,
        label: '简阳'
      }, {
        value: 18,
        label: '金堂'
      }, {
        value: 19,
        label: '大邑'
      }, {
        value: 20,
        label: '蒲江'
      }, {
        value: 21,
        label: '新津'
      }, {
        value: 22,
        label: '青白江'
      },
      {
        value: 12,
        label: '其他'
      }],
      locationchecked: [],
      // teachMethod: ['不限', '老师上门辅导', '线上辅导'],
      teachMethod: [{
        value: null,
        label: '不限'
      },
      {
        value: 0,
        label: '老师上门辅导'
      },
      {
        value: 1,
        label: '线上辅导'
      }],
      teachMethodchecked: '',
      Authorization: '',
      ifnew: 1,
      version: 0,
    }
  },
  methods: {
    yanzhengma() {
      if (this.phone == '') {
        this.$message.error('请输入手机号');
        return false;
      }
      let time = 60;
      let timer = setInterval(() => {
        time--;
        this.yanzhengmatext = time + 's';
        if (time == 0) {
          clearInterval(timer);
          this.yanzhengmatext = '获取验证码';
        }
      }, 1000);
      let formData = new FormData();
      formData.append('phone', this.phone);
      this.$http.post('/Api/User/User/Web/Phone/Verify', formData, {
        headers: {
          "Authorization": localStorage.getItem('Authorization'),
          'Content-Type': 'multipart/form-data',

        }
      }).then(res => {
        console.log(res);
        if (res.data.msg == 'SUCCESS') {
          this.$message({
            message: '验证码已发送',
            type: 'success'
          });
        } else {
          this.$message({
            message: '验证码发送失败',
            type: 'error'
          });
        }
      }).catch(err => {
        console.log(err);
      })

    },
    yanzhengcode() {
      if (this.phonecode == '') {
        this.$message({
          message: '请输入验证码',
          type: 'error'
        });
        return false;
      }
      let formData = new FormData();
      formData.append('code', this.phonecode);
      this.$http.post('/Api/User/User/Web/Phone/Verify/Callback', formData, {
        headers: {
          'Authorization': localStorage.getItem('Authorization'),
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        console.log(res);
        if (res.data.msg == 'SUCCESS') {
          this.$message({
            message: '验证成功',
            type: 'success'
          });
        }
        else {
          this.$message({
            message: '验证失败',
            type: 'error'
          });
        }
      }).catch(err => {
        console.log(err);
      })
    },
    addItem() {
      // 这里从select组件中获取当前选中的值
      let currentValue = this.$refs.select.value;
      // 判断是否已经存在于selectedItems中
      if (this.selectedItems.includes(currentValue)) {
        // 如果已经存在，就提示用户
        ElMessage.warning("该条目已经存在");
      } else {
        // 如果不存在，就添加进去，并提示用户
        this.selectedItems.push(currentValue);
        ElMessage.success("添加成功");
      }
    },
    addCascader() {
      if (this.fanweichecked.length == 3) {
        this.$message({
          message: '最多3个科目哦~~',
          type: 'warning'
        });

      }
      else {
        this.fanweichecked.push({
          value: [],
        });
      }

    },
    deleteCascader(index) {
      // 点击删除按钮后，判断是否可以删除该选择器组
      if (this.fanweichecked.length > 1) {
        // 如果选择器组数量大于1，就从fanweichecked数组中移除该对象，并提示用户
        this.fanweichecked.splice(index, 1);
      } else {
        // 如果选择器组数量等于1，就不能删除，并提示用户
        ElMessage.warning("不能删除");
      }
    },
    submit() {
      // for (let key in this.$data) {
      //   if (this.$data[key] === '' || this.$data[key].length == 0 || this.fanweichecked[0].value.length == 0) {
      //     console.error(`The ${key} field is empty`);
      //     this.$message.error('您输入的信息不完整哦~');
      //     return false;
      //   }
      // }
      const phoneReg = /^1[3456789]\d{9}$/;
      if (!phoneReg.test(this.phone)) {
        this.$message.error('手机号格式不对哦~');
        return false;
      }
      let newdata = {}
      newdata.phone = this.phone
      newdata.avatar = this.avatar
      newdata.awards = this.award
      newdata.certificateType = this.quality
      newdata.gender = this.sex
      newdata.graduateEducation = this.biye.xueweichecked
      newdata.collegeStudentGrade = this.daxuesheng.xueweichecked
      newdata.graduateProfession = this.biye.zhiyechecked
      newdata.isCollegeStudent = this.identitychecked
      newdata.comment = this.comment
      newdata.isOnline = this.teachMethodchecked
      newdata.residentAddress = '成都市'
      if (this.identitychecked == 1) {
        newdata.major = this.daxuesheng.zhuanye
        newdata.university = this.daxuesheng.school
      }
      else {
        newdata.major = this.biye.zhuanye
        newdata.university = this.biye.school
      }
      newdata.name = this.username

      // newdata.residentAddress = ''
      newdata.teachingAreas = this.locationchecked
      newdata.selfEvaluation = this.selfAssess
      newdata.teachingExperience = this.teachExp
      newdata.teachingPriceHigh = this.money2
      newdata.teachingPriceLow = this.money1
      newdata.teachingItems = []
      newdata.teachingTimes = this.studytimechecked
      this.fanweichecked.forEach(element => {
        newdata.teachingItems.push(element.value.join(''))
      });
      console.log(JSON.stringify(newdata));
      if (this.ifnew == 1) {
        this.$http.post('/Api/Teacher', JSON.stringify(newdata), {
          headers: {
            'Authorization': this.Authorization,
            'Content-Type': 'application/json'
          }
        }).then(res => {
          console.log(res);
          if (res.data.code == 302) {
            this.$message.error('您输入的信息不完整哦~');
            return false;
          }
          this.$router.push('/personteacher/jianlisucces#0')
        })
      }
      if (this.ifnew == 0) {
        newdata.version = this.version
        this.$http.put('/Api/Teacher', JSON.stringify(newdata), {
          headers: {
            'Authorization': this.Authorization,
            'Content-Type': 'application/json'
          }
        }).then(res => {
          console.log(res);
          this.$router.push('/personteacher/jianlisucces#0')
        })
      }


    }, handleRemove(file, fileList) {
      // console.log(file, fileList);
    },
    handlePreview(file) {
      // console.log(file);
    },
    handleExceed() {
      this.$message.warning(`只能选择一张照片哦~`);
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    upSuccess(response, file, fileList) {
      // console.log(response, file, fileList);
    },

    uploadFile(file) {

      let formData = new FormData();
      formData.append('uploadFile', file.file);
      this.$http.post('/Api/Teacher/Honest', formData, {
        headers: {
          'Authorization': this.Authorization,
          'Content-Type': 'application/form-data'
        }
      }).then(res => {
        console.log(res);
        this.avatar = res.data.data
      }).catch(err => {
        console.error(err);
      });
    },
  },
  watch: {
    // phone(newVal, oldVal) {
    //   if (!(/^1[3456789]\d{9}$/.test(newVal))) {
    //     this.$nextTick(() => {
    //       this.phone = oldVal;
    //     });
    //     this.$message({
    //       message: '手机号格式不对哦',
    //       type: 'warning'
    //     });
    //   }
    // },
    locationchecked(n, o) {
      if (n.length > 4) {
        this.ifcollapsequyu = true
      }
      else {
        this.ifcollapsequyu = false
      }
    },
    studytimechecked(n, o) {
      if (n.length > 3) {
        this.ifcollapsetime = true
      }
      else {
        this.ifcollapsetime = false
      }
    }
  },
  created() {
    this.Authorization = localStorage.getItem('Authorization')
    this.$http.get('/Api/Teacher', {
      headers: {
        'Authorization': this.Authorization
      }
    }).then(res => {
      this.ifnew = 0
      let alldata = res.data.data;

      console.log(alldata);
      let dateStr = alldata.updateTime
      let date = new Date(dateStr);
      this.year = date.getFullYear(); // 获取年份
      this.month = date.getMonth() + 1; // 获取月份，注意月份是从0开始的，所以需要+1
      this.day = date.getDate(); // 获取日期
      this.hour = date.getHours(); // 获取小时
      this.minute = date.getMinutes(); // 获取分钟
      this.username = alldata.name
      this.avatar = alldata.avatar
      this.sex = alldata.gender
      this.phone = alldata.phone
      this.biye.zhuanye = alldata.major
      this.daxuesheng.zhuanye = alldata.major
      this.biye.xueweichecked = alldata.graduateEducation
      this.daxuesheng.xueweichecked = alldata.collegeStudentGrade
      this.identitychecked = alldata.isCollegeStudent
      this.daxuesheng.school = alldata.university
      if (this.identitychecked == "2") {
        this.identitychecked = 1
      }
      this.selfAssess = alldata.selfEvaluation
      this.award = alldata.awards
      this.teachExp = alldata.teachingExperience
      this.money1 = alldata.teachingPriceLow
      this.money2 = alldata.teachingPriceHigh
      this.locationchecked = alldata.teachingAreas
      this.studytimechecked = alldata.teachingTimes
      this.version = alldata.version
      if (alldata.certificateType > 0) {
        this.quality = 1
      }
      else {
        this.quality = 0
      }
      alldata.teachingItems.forEach(element => {
        let obj = {}
        if (element === null) {
          return;
        }
        let str = element.toString()
        obj.value = [str.charAt(0), str.charAt(1)]
        this.fanweichecked.push(obj)
      });
      this.biye.school = alldata.university
      this.comment = alldata.comment
      this.teachMethodchecked = alldata.isOnline
      this.biye.zhiyechecked = alldata.graduateProfession
    }).catch(err => {
      console.log(err);
      this.ifnew = 1
    })
  }

}
</script>

<style scoped>
.button {
  width: 90px;
  height: 32px;
  background: rgb(1, 162, 153);
  border-radius: 4px;
  border: none;
  /* Small Button */
  color: rgb(255, 254, 254);
  font-family: Microsoft YaHei;
  font-size: 13px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0px;
  text-align: center;
  margin-left: 10px;
  transform: translateY(-5px)
}

/deep/ .el-cascader .el-input .el-input__inner,
/deep/ .el-select .el-input__inner {
  height: 24px;
}

#quyu /deep/ .el-select .el-input__inner {
  height: 34px;
}



/deep/ .el-cascader .el-input .el-icon-arrow-down,
/deep/ .el-selcet .el-input .el-icon-arrow-down {
  position: relative;
  font-size: 13.9968px;
  width: 24px;
  height: 24px;
}



/deep/ .el-cascader .el-input .el-icon-arrow-down::before,
/deep/ .el-select .el-input .el-icon-arrow-down::before {
  position: absolute;
  top: -4.992px;
  left: 0;
  width: 100%;
  height: 100%;
}

/deep/ .el-icon-arrow-up:before {
  content: "\E6E1";
  position: absolute;
  top: -7.008px;
  left: 4.992px;
}

#quyu /deep/ .el-icon-arrow-up:before {
  content: "\E6E1";
  position: absolute;
  top: -5.008px;
  left: 4.992px;
}

/deep/ .el-icon-close:before {
  position: absolute;
  content: "\E6DB";
  top: .9984px;
  left: .9984px;
}


input {
  width: 100%;
  height: 100%;
}

.emptyinput {
  /* input-完整/small/default/无/off/off/off/off/off (style) */
  width: 169.9968px;
  height: 24px;
  box-sizing: border-box;
  background: rgb(255, 255, 255);
  border: .9984px solid rgb(220, 223, 230);
  border-radius:
    3.9936px;
  padding-left: 10.0032px;
  font-size: 12px;
  color: rgb(96, 98, 102);
  font-family: 苹方;
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.0192px;
  text-align: left;
}


.emptyinput::placeholder {
  color: rgb(168, 171, 178);
  font-family: 苹方;
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.0192px;
  text-align: left;
  height: 24px;
}

.emptyinput:focus {
  background: rgb(255, 255, 255);
  outline: .9984px solid rgb(220, 223, 230);
}



.flex {
  display: flex;
  justify-content: space-between;
}

.time {
  /* 上次更新时间：2023年5月4日20：50 */
  height: 23.0016px;
  color: rgb(48, 49, 51);
  font-family: "PingFang";
  font-size: 18.0096px;
  font-weight: 550;
  line-height: 24.9984px;
  text-align: left;
}


#basic .title img,
#course .title img,
#edu .title img {
  width: 18.0096px;
  height: 18.0096px;
  transform: translateY(3.9936px);
}

#basic .title div,
#course .title div,
#edu .title div {
  /* 姓名 */
  display: inline-block;
  height: 22.0032px;
  width: 70.0096px;
  color: rgb(48, 49, 51);
  font-family: 苹方;
  font-size: 13.9968px;
  font-weight: 400;
  line-height: 22.0032px;
  letter-spacing: -0.0192px;
  text-align: left;
  margin-left: 6.0096px;
  margin-right: 20px;
}

#basic .answer,
#course .answer,
#edu .answer,
#basic .answer input,
#course .answer input,
#edu .answer input {
  /* 18100000000 */
  height: 22.0032px;
  color: rgb(96, 98, 102);
  font-family: 苹方;
  font-size: 13.9968px;
  font-weight: 400;
  line-height: 22.0032px;
  letter-spacing: -0.0192px;
  text-align: left;
}

#basic /deep/ .el-radio__input.is-checked+.el-radio__label {
  color: #606266;
}

#basic /deep/ .el-radio__input.is-checked .el-radio__inner {
  background: rgb(1, 162, 153);
  border: 3.9936px solid rgb(1, 162, 153);
}

#basic /deep/ .el-radio {
  margin-right: 14.9952px;
}

.el-radio-group {
  margin-top: 4.992px;
}

.fanwei {
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
}

.fanwei img {
  margin-left: 14.9952px;
  margin-bottom: 12px;
}

.introduce .title {
  height: 27.9936px;
  display: flex;
  position: relative;
}

.introTxt {
  width: 656.0064px;
  padding: 12px;
  height: auto;
  box-sizing: border-box;
  color: rgb(96, 98, 102);
  font-family: 苹方;
  font-size: 13.9968px;
  font-weight: 400;
  line-height: 20.0064px;
  letter-spacing: 0px;
  text-align: left;
}

.introduce .title::after {
  display: none;
  content: '';
  position: absolute;
  width: 639.9936px;
  height: .9984px;
  top: 25.9968px;
  background: rgba(0, 0, 0, 0.15);
}

.introduce .title img {
  width: 18.0096px;
  height: 18.0096px;
  transform: translateY(2.9952px);
}

.introduce .title div {
  /* 获奖经历 */
  height: 22.0032px;
  color: rgb(48, 49, 51);
  font-family: 苹方;
  font-size: 15.9936px;
  font-weight: 400;
  line-height: 22.0032px;
  letter-spacing: 0px;
  text-align: left;
  margin-left: 2.9952px;
}

#course th {
  width: 39.9936px;
  height: 39.9936px;
  color: rgb(96, 98, 102);
  font-family: 苹方;
  font-size: 12px;
  font-weight: 400;
  line-height: 20.0064px;
  letter-spacing: -0.0192px;
  text-align: center;


}

table {
  border-collapse: collapse;
  box-shadow: 1.9968px 1.9968px 8.0064px rgba(0, 0, 0, 0.25);
  margin-top: 10.0032px;
  margin-left: 21.0048px;
}



#course tr {
  border: none;
  width: 39.9936px;
  height: 36px;
  color: rgb(96, 98, 102);
  font-family: 苹方;
  font-size: 12px;
  font-weight: 400;
  line-height: 20.0064px;
  letter-spacing: -0.0192px;
  text-align: center;

}

#course input {
  height: 30.0096px;
  width: 30.0096px;
  border-radius: 13.9968px;
}

.checkbox {
  position: relative;
  display: inline-block;
  width: 13.9968px;
  height: 13.9968px;
  margin-right: 10.0032px;
}

.checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.checkmark {
  position: absolute;
  top: 1.9968px;
  left: 6.0096px;
  height: 13.9968px;
  width: 13.9968px;
  border-radius: 50%;
  background-color: transparent;
  border: none;
}

.checkbox input:checked+.checkmark {
  background-color: #01A299;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.checkbox input:checked+.checkmark:after {
  display: block;
}

.checkmark:after {
  left: 4.992px;
  top: 1.9968px;
  width: 2.9952px;
  height: 6.0096px;
  border: solid white;
  border-width: 0 1.9968px 1.9968px 0;
  transform: rotate(45deg);
}
</style>


// WEBPACK FOOTER //
// src/components/pages/teacherjianli.vue